<template>
  <div>
    <el-form
      ref="lxsqForm"
      :rules="rules"
      label-width="130px"
      :hide-required-asterisk="false"
      :model="baseInfo"
    >
      <div class="card">
        <el-row>
          <el-col :span="24" class="label" style="display: flex">
            <div>基本信息</div>
            <div>
              <div class="btn">
                <el-button
                  type="primary"
                  icon="el-icon-upload"
                  size="small"
                  @click="handleToUpload"
                  >上传附件</el-button
                >
                <el-button
                  type="primary"
                  icon="el-icon-download"
                  size="small"
                  @click="handleToDownload"
                  >下载模板</el-button
                >
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="card_content">
          <el-row>
            <el-col :span="24">
              <el-form-item label="课题编号：" prop="courseId">
                <el-input
                  show-word-limit
                  placeholder="请输入课题编号"
                  v-model="baseInfo.courseId"
                  maxlength="100"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="课题名称：" prop="courseName">
                <el-input
                  show-word-limit
                  placeholder="请输入课题名称"
                  v-model="baseInfo.courseName"
                  maxlength="100"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="baseInfo.courseGroup == 3">
            <el-col :span="24">
              <el-form-item label="项目类型：" prop="courseProject">
                <el-select
                  ref="courseProject"
                  v-model="baseInfo.courseProject"
                  placeholder="请选择项目类型"
                  style="width: 100%"
                  class="filter-item"
                  :disabled="true"
                >
                  <el-option
                    v-for="item in projectOptions"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="课题归属部门：" prop="bmbh">
                <el-select
                  ref="bmbh"
                  v-model="baseInfo.bmbh"
                  placeholder="请选择归属部门"
                  style="width: 100%"
                  class="filter-item"
                  :multiple="true"
                >
                  <el-option
                    v-for="item in bmOptions"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="课题导师：" prop="courseTeacher">
                <el-select
                  collapse-tags
                  ref="ktds"
                  v-model="baseInfo.courseTeacher"
                  placeholder="请选择导师"
                  size="small"
                  style="width: 100%"
                  class="filter-item"
                >
                  <el-option
                    v-for="item in ktdsOptions"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="课题负责人：" prop="courseLeader">
                <treeselect
                  v-model="baseInfo.courseLeader"
                  placeholder="请选择员工"
                  :options="deptUser"
                  :disable-branch-nodes="true"
                  :show-count="true"
                  value-consists-of="LEAF_PRIORITY"
                  no-results-text="未搜到任何结果"
                  :clear-on-select="true"
                  :normalizer="normalizer"
                  style="width: 100%"
                  size="small"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="专业职称：" prop="professional">
                <el-input
                  show-word-limit
                  placeholder="请输入专业职称"
                  v-model="baseInfo.professional"
                  maxlength="100"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="工作单位：" prop="workPlace">
                <el-input
                  show-word-limit
                  placeholder="请输入工作单位"
                  v-model="baseInfo.workPlace"
                  maxlength="100"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="E-mail：" prop="email">
                <el-input
                  show-word-limit
                  placeholder="请输入邮箱地址"
                  v-model="baseInfo.email"
                  maxlength="100"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="最终成果形式：" prop="finalAchievementForm">
                <el-select
                  ref="gsbm"
                  v-model="baseInfo.finalAchievementForm"
                  placeholder="请选择最终成果形式"
                  style="width: 100%"
                  class="filter-item"
                >
                  <el-option
                    v-for="item in zzcgxsOptions"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课题类型：" prop="courseType">
                <el-select
                  ref="gsbm"
                  v-model="baseInfo.courseType"
                  placeholder="请选择课题类型"
                  style="width: 100%"
                  class="filter-item"
                >
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="研究专长：" prop="studySpeciality">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="200"
                  show-word-limit
                  placeholder="请输入研究专长"
                  v-model="baseInfo.studySpeciality"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注：" prop="remark">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="200"
                  show-word-limit
                  placeholder="请输入备注"
                  v-model="baseInfo.remark"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="card">
        <el-row>
          <el-col :span="24" class="label">
            <span>成员管理</span>
            <span>
              <el-button
                type="primary"
                icon="el-icon-plus"
                size="small"
                style="
                  margin-left: 15px;
                  color: #fff;
                  background-color: #1c84c6;
                  border-color: #1c84c6;
                "
                @click="addDialog = true"
                >添加成员</el-button
              ></span
            >
          </el-col>
        </el-row>
        <el-table
          :max-height="height"
          :data="cyList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <el-table-column
            label="操作"
            align="left"
            min-width="150px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button type="primary" @click="editCy(scope.row)" size="mini">
                编辑
              </el-button>
              <el-button type="danger" @click="delCy(scope.row)" size="mini">
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="姓名"
            align="left"
            prop="memberName"
            min-width="60px"
            :show-overflow-tooltip="true"
          />

          <el-table-column
            label="性别"
            align="left"
            prop="sex"
            min-width="50px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="出生日期"
            align="left"
            prop="birthday"
            min-width="100px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="职称职务"
            align="left"
            prop="post"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="工作单位"
            align="left"
            prop="workPlace"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="联系电话"
            align="left"
            prop="phone"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="课题承担任务"
            align="left"
            prop="courseMission"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <pagination
          v-show="cyCount > 0"
          :total="cyCount"
          :page.sync="cylistQuery.page"
          :limit="cylistQuery.pageSize"
          @pagination="getCyList"
        />
      </div>
      <div
        class="card card3"
        v-if="baseInfo.metaPropList && baseInfo.metaPropList.length > 0"
      >
        <el-row>
          <el-col :span="24" class="label"> 研究方案 </el-col>
        </el-row>
        <el-row>
          <el-col
            :span="24"
            v-for="(item2, index2) in baseInfo.metaPropList"
            :key="index2"
          >
            <div class="content">
              <div v-if="item2.type == 1">
                <div class="content_title">
                  <span v-if="item2.required == '1'" class="red">*</span>
                  <span>{{ item2.cname }}</span>
                </div>
                <div class="content_text">
                  <el-input
                    v-model="item2.propValue"
                    type="textarea"
                    :autosize="{ minRows: 6 }"
                    show-word-limit
                  >
                  </el-input>
                </div>
              </div>
              <div v-else>
                <div class="content_title">
                  <span v-if="item2.required == '1'" class="red">*</span>
                  <span>{{ item2.cname }}</span>
                </div>
                <div :id="`wangEditor_lxsq_form__${index2}`"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="card card4" v-if="feedbackList.length > 0">
        <el-row>
          <el-col :span="24" class="label"> 意见反馈处理情况 </el-col>
          <div class="card4_div">
            <el-col>
              <el-radio-group v-model="baseInfo.feedbackType">
                <el-radio label="1">意见反馈已处理完毕</el-radio>
                <el-radio label="2">暂时不处理</el-radio>
              </el-radio-group>
            </el-col>
            <el-col>
              <el-table
                :max-height="height"
                :data="feedbackList"
                fit
                highlight-current-row
                :default-sort="{ prop: 'date', order: 'descending' }"
                tooltip-effect="dark"
              >
                <el-table-column
                  label="状态"
                  align="left"
                  prop="status"
                  min-width="120px"
                  :show-overflow-tooltip="true"
                />

                <el-table-column
                  label="反馈人"
                  align="left"
                  prop="ygbh"
                  min-width="120px"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="反馈时间"
                  align="left"
                  prop="feedbackTime"
                  min-width="150px"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="意见反馈"
                  align="left"
                  prop="content"
                  min-width="250px"
                  :show-overflow-tooltip="true"
                />
                <template slot="empty">
                  <div class="nodata">
                    <img src="@/img/nodata.png" alt="" width="160" />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-table>
            </el-col>
          </div>
        </el-row>
      </div>
    </el-form>
    <el-dialog
      title="添加成员"
      :visible.sync="addDialog"
      width="700px"
      v-if="addDialog"
      :closeOnClickModal="false"
      append-to-body
    >
      <AddMembers
        ref="addMembers"
        @giveFather="getCyList"
        :mxParams="mxParams"
      ></AddMembers>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveAddMembersForm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑成员"
      :visible.sync="editDialog"
      width="700px"
      v-if="editDialog"
      :closeOnClickModal="false"
      append-to-body
    >
      <EditMembers
        :mxParams="mxParams"
        ref="editMembers"
        @giveFather="getCyList"
      ></EditMembers>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveEditMembersForm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="课题结果查看"
      :visible.sync="handleResultDialog"
      width="90%"
      v-if="handleResultDialog"
      append-to-body
      :closeOnClickModal="false"
    >
      <CourseResult :mxParams="mxParams"></CourseResult>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleResultDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import wangEditor from "wangeditor";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";
import { mapGetters } from "vuex";
import AddMembers from "./addMembers.vue";
import EditMembers from "./editMembers.vue";
import {
  getListCourseMember,
  deleteMemberById,
  getItemApply,
  getCourseQueryCondition,
  insertItemApply,
  listUnfinishFeedback,
  courseJudgesList,
} from "@/api/course.js";
import Pagination from "@/components/Pagination";
import { getDictData } from "@/api/task.js";

export default {
  components: {
    Treeselect,
    AddMembers,
    EditMembers,
    Pagination,
    CourseResult: () => import("../result.vue"),
  },
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      addDialog: false,
      editDialog: false,
      baseInfo: {},
      height: 500,
      rules: {
        courseName: [
          { required: true, message: "课题名称不能为空", trigger: "blur" },
        ],
        bmbh: [
          { required: true, message: "课题归属部门不能为空", trigger: "blur" },
        ],
        courseLeader: [
          { required: true, message: "课题负责人不能为空", trigger: "blur" },
        ],
        finalAchievementForm: [
          { required: true, message: "最终成果形式不能为空", trigger: "blur" },
        ],
        courseType: [
          { required: true, message: "课题类型形式不能为空", trigger: "blur" },
        ],
        studySpeciality: [
          { required: true, message: "研究专长形式不能为空", trigger: "blur" },
        ],
      },
      cyList: [],
      cyCount: 0,
      cylistQuery: {
        page: 1,
        pageSize: 10,
      },

      editorList: [],
      bmOptions: [],
      zzcgxsOptions: [],
      typeOptions: [],
      ktdsOptions: [],
      feedbackList: [],
      projectOptions: [],
      handleResultDialog: false,
    };
  },
  created() {
    this.getCyList();
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    //归属部门
    getCourseQueryCondition({ type: 1 }).then((res) => {
      if (res.code === 0) {
        this.bmOptions = res.data;
      }
    });
    //最终成果形式
    getDictData("pmp_course_achievement", 1).then((res) => {
      if (res.code === 0) {
        this.zzcgxsOptions = res.data;
      }
    });
    //课题类型
    getDictData("pmp_course_type", 1).then((res) => {
      if (res.code === 0) {
        this.typeOptions = res.data;
      }
    });
    //导师
    courseJudgesList({ courseId: this.mxParams.id }).then((res) => {
      if (res.code === 0) {
        this.ktdsOptions = res.data;
      }
    });
    //项目类型
    getDictData("pmp_course_project", 1).then((res) => {
      if (res.code === 0) {
        this.projectOptions = res.data;
      }
    });
    getItemApply({ courseId: this.mxParams.id }).then((res) => {
      if (res.code == 0) {
        this.baseInfo = res.data;
        if (this.baseInfo.bmbh) {
          this.baseInfo.bmbh = this.baseInfo.bmbh.split(",");
          this.mxParams.aid = res.data.applyId;
          this.mxParams.applyId = res.data.applyId;
        }
      }
    });
    listUnfinishFeedback({ applyId: this.mxParams.aid }).then((res) => {
      if (res.code == 0) {
        this.feedbackList = res.data;
        if (this.feedbackList && this.feedbackList.length > 0) {
          this.baseInfo.feedbackType = "1";
        }
      }
    });
  },
  mounted() {
    const timer = setInterval(() => {
      if (this.baseInfo.metaPropList && this.baseInfo.metaPropList.length > 0) {
        for (let i = 0; i < this.baseInfo.metaPropList.length; i++) {
          if (this.baseInfo.metaPropList[i].type == 2) {
            let editor = new wangEditor(`#wangEditor_lxsq_form__${i}`);
            editor = this.editorConfig(editor);
            // if (this.baseInfo.metaPropList[i].propValue) {
            //   editor.txt.html(this.baseInfo.metaPropList[i].propValue);
            // } else {
            //   editor.txt.html(this.baseInfo.metaPropList[i].defaultValue);
            // }
            if (this.baseInfo.courseType) {
              editor.txt.html(this.baseInfo.metaPropList[i].propValue);
            } else {
              editor.txt.html(this.baseInfo.metaPropList[i].defaultValue);
            }
            this.editorList.push(editor);
          } else {
            if (!this.baseInfo.courseType) {
              this.baseInfo.metaPropList[i].propValue =
                this.baseInfo.metaPropList[i].defaultValue;
            }
          }
        }
        clearInterval(timer);
      }
    }, 50);
  },
  methods: {
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中

      editor.create();
      return editor;
    },
    getCyList() {
      this.addDialog = false;
      this.editDialog = false;
      getListCourseMember({
        applyId: this.mxParams.aid ? this.mxParams.aid : this.mxParams.applyId,
        ...this.cylistQuery,
      }).then((res2) => {
        if (res2.code == 0) {
          this.cyList = res2.data;
          this.cyCount = res2.count;
        }
      });
    },
    editCy(row) {
      this.editDialog = true;
      this.mxParams = row;
    },
    delCy(row) {
      deleteMemberById({ memberId: row.memberId }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getCyList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getSon(temp) {
      this.addDialog = false;
      this.editDialog = false;
    },
    saveForm() {
      this.$refs["lxsqForm"].validate((valid) => {
        if (valid) {
          const temp = [];
          for (let i of this.editorList) {
            temp.push(i.txt.html());
          }
          let txtIndex = 0;
          for (let i in this.baseInfo.metaPropList) {
            if (this.baseInfo.metaPropList[i].type == 2) {
              this.baseInfo.metaPropList[i].propValue = temp[txtIndex];
              txtIndex = txtIndex + 1;
            }
            if (
              this.baseInfo.metaPropList[i].required == "1" &&
              !this.baseInfo.metaPropList[i].propValue
            ) {
              this.$message.error(
                "请输入" + this.baseInfo.metaPropList[i].cname
              );
              return;
            }
          }
          if (this.baseInfo.bmbh) {
            this.baseInfo.bmbh = this.baseInfo.bmbh.join(",");
          }
          insertItemApply({ ...this.baseInfo }).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.$emit("getParentForm");
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    saveAddMembersForm() {
      this.$refs.addMembers.saveForm();
    },
    saveEditMembersForm() {
      this.$refs.editMembers.saveForm();
    },
    handleToDownload() {
      const { courseType } = this.baseInfo;
      this.$router.push({
        name: "courseFile",
        query: { ktsx: courseType + "", wjlx: "2", ssjd: "3" },
      });
    },
    handleToUpload() {
      const row = { id: this.baseInfo.courseId, step: 17 };
      this.handleView(row);
    },
    handleView(row) {
      this.handleResultDialog = true;
      this.mxParams = row;
    },
  },
};
</script>

<style lang="less" scoped>
.card {
  //   border-bottom: 2px solid #f3f3f3;
  .label {
    font-size: 16px;
    font-weight: bold;
    height: 44px;
    line-height: 44px;
    padding-left: 15px;
  }
  .card_content {
    padding: 0 10%;
  }
}
.card3 {
  .card3_label {
    margin-left: 120px;
    height: 44px;
    line-height: 44px;
    font-weight: bold;
    font-size: 15px;
  }
}
.card:nth-of-type(1) {
  margin-top: 0;
}
.content {
  margin-bottom: 30px;

  .content_title {
    font-weight: 700;
    margin-bottom: 15px;
  }
  .content_text {
    padding: 5px 15px;
    margin-right: 15px;
  }
}
.red {
  color: #ff0000;
  margin-right: 5px;
}
.btn {
  position: fixed;
  right: 120px;
  z-index: 100001;
}
</style>